import { render, staticRenderFns } from "./m_index.vue?vue&type=template&id=40457af4&"
import script from "./m_index.vue?vue&type=script&lang=js&"
export * from "./m_index.vue?vue&type=script&lang=js&"
import style0 from "./m_index.vue?vue&type=style&index=0&id=40457af4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports